import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setDealerInformationAction } from '../../../stores/actionTypes/authActions';
import { useNavigate } from 'react-router-dom';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchDealerInfo = async () => {
    let data = null;
    await axiosInstance
      .get('/dealers/dealerInfo')
      .then((response) => {
        dispatch(setDealerInformationAction(response?.data?.data));
        data = response?.data;
      })
      .catch((error) => {
        dispatch(setDealerInformationAction({}));
        showAlert(error?.response?.data?.error || error?.message, 'warning');
        data = error?.response?.data;
      });
    return data;
  };

  return {
    fetchDealerInfo,
  };
}
